import { FontEntry } from '../../types/font'

export const poppins: FontEntry = {
  displayName: 'Poppins',
  weights: {
    400: {
      normal: { file: 'Poppins-Regular', extension: 'ttf', format: 'truetype' },
      italic: null
    },
    600: {
      normal: { file: 'Poppins-SemiBold', extension: 'ttf', format: 'truetype' },
      italic: null
    },
    700: { normal: { file: 'Poppins-Bold', extension: 'ttf', format: 'truetype' }, italic: null }
  },
  fallbackMetrics: {
    arial: {
      regular: {
        sizeAdjust: 108.99,
        ascentOverride: 96.34,
        descentOverride: 32.11,
        lineGapOverride: 9.18
      },
      bold: {
        sizeAdjust: 105.99,
        ascentOverride: 99.07,
        descentOverride: 33.02,
        lineGapOverride: 9.43
      }
    },
    roboto: {
      regular: {
        sizeAdjust: 110.59,
        ascentOverride: 94.95,
        descentOverride: 31.65,
        lineGapOverride: 9.04
      },
      bold: {
        sizeAdjust: 112.29,
        ascentOverride: 93.51,
        descentOverride: 31.17,
        lineGapOverride: 8.91
      }
    }
  }
}
